module.exports = __webpack_public_path__ + "static/media/desktopPro.c05ebd31.png";